import request from '@/utils/newRequest'
import axios from 'axios'
//用户账号密码注册
export function EnterpriseRegister(data) {
  return request({
    url: '/enterprise_background/EnterpriseRegister',
    method: 'post',
    data
  })
}
//发送验证码
export function SendMsg(data) {
  return request({
    url: '/enterprise_background/RegisterSendMsg',
    method: 'post',
    data
  })
}
//注册成功统计（仅限宣传视频跳转过去请求）
export function UserRegisterStatistics(data) {
  return request({
    url: '/publicity_statistics/UserRegisterStatistics',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js